import React from "react";
import { useParams } from "react-router-dom";
import { useFormTemplateContext } from "../../formTemplateContext";
import { Content } from "./Content";
import { EditFormTemplateProvider } from "./context";
import { ImportFromJSON } from "./ImportFromJSON";

export const ContentTab = () => {
  const { organization, formTemplate } = useFormTemplateContext();
  const { enrollmentPeriodId = "" } = useParams();

  type Mode = "content" | "import";
  const [mode, setMode] = React.useState<Mode>("content");

  return (
    <EditFormTemplateProvider
      enrollmentPeriodId={enrollmentPeriodId}
      formTemplateId={formTemplate.id}
    >
      {mode === "import" ? (
        <ImportFromJSON onBack={() => setMode("content")} />
      ) : null}
      {mode === "content" ? (
        <Content
          organizationId={organization.id}
          onImportFromJSON={() => setMode("import")}
        />
      ) : null}
    </EditFormTemplateProvider>
  );
};
